import React from "react";
import Anonymous from "../Anonymous";
import Button from "../common/button/Button";
import ButtonType from "../common/button/ButtonType";
import ButtonAction from "../common/button/ButtonAction";
import { useNavigate, useParams } from "react-router-dom";
import SETTINGS from "../../globals";
import AppSections from "../../utils/AppSections";

function EmailConfirmation() {
  const navigate = useNavigate();
  const { actionStatus } = useParams();

  return (
    <Anonymous>
      {actionStatus == "confirmed" && (
        <div className="h-[calc(100vh-400px)]">
          <div className="mt-40">
            Thank you for confirming your email address.
            <br />
            You can now authenticate and access the content of the ChemiNova
            Platform.
            <br />
            <br />
            <Button
              className="mt-10"
              type={ButtonType.FILL_TEXT}
              label="Go to authentication"
              purpose={ButtonAction.INFO}
              onClick={() => {
                navigate(SETTINGS.get_path({ section: AppSections.SIGN_IN }));
              }}
            />
          </div>
        </div>
      )}

      {actionStatus == "resent" && (
        <div className="h-[calc(100vh-400px)]">
          <div className="mt-40">
            A new confirmation link has been sent to your email address.
            <br />
            If you cannot find the message in your inbox in the next 10 minutes,
            search also in Junk/Spam folders.
          </div>
        </div>
      )}

      {actionStatus == "registered" && (
        <div className="h-[calc(100vh-400px)]">
          <div className="mt-40">
            Thank you for joining ChemiNova! Your account has been created, but
            is not yet active.
            <br />
            A link to confirm your email address has been sent to your inbox.
            <br />
            If you cannot find the message in your inbox in the next 10 minutes,
            search also in Junk/Spam folders.
          </div>
        </div>
      )}
    </Anonymous>
  );
}

export default EmailConfirmation;
